import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { OperationStateService } from './operation-state.service';
import { ExecutionState } from '../../../assets/data/enum/executionState';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';
import { SAASBRANDNAME } from '../../../assets/data/enum/saasBrandName.enum';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private themeConfig = ThemeConfig;
  brand = SAASBRANDNAME;

  constructor(
    private operationStateService: OperationStateService,
    private authenticationService: AuthenticationService
  ) {}

  handleError(error: HttpErrorResponse): void {
    switch (error.status) {
      case 400:
        this.handleBadRequest();
        break;
      case 401:
        this.handleUnauthorized();
        break;
      case 403:
        this.handleForbidden(error);
        break;
      case 404:
        this.handleNotFound();
        break;
      case 405:
        this.handleMethodNotAllowed();
        break;
      case 422:
        this.handleValidationError();
        break;
      case 4445:
        this.handleCustom4445Error();
        break;
      default:
        //this.handleGenericError();
        break;
    }
  }

  private handleBadRequest(): void {
    this.operationStateService.showOperationInProgress$.next(ExecutionState.nostate);
  }

  private handleUnauthorized(): void {
    this.operationStateService.showOperationInProgress$.next(ExecutionState.error);
    this.operationStateService.setBarMessage(
      'form.placeholder.label_invalid_credentials',
      'form.placeholder.label_subtitle'
    );
  }

  private handleForbidden(error: HttpErrorResponse): void {
    if (error.url && error.url.includes('hubfarm/fascicolo/')) {
      throw error;
    }
    this.operationStateService.showOperationInProgress$.next(ExecutionState.error);
    this.operationStateService.setBarMessage(
      'alert_errorHandling.label_HTTP500',
      'alert_errorHandling.subtitle'
    );
  }

  private handleNotFound(): void {
    this.operationStateService.showOperationInProgress$.next(ExecutionState.nostate);
  }

  private handleMethodNotAllowed(): void {
    this.operationStateService.showOperationInProgress$.next(ExecutionState.error);
    this.operationStateService.setBarMessage(
      'alert_errorHandling.label_HTTP405',
      'alert_errorHandling.subtitle'
    );
  }

  private handleValidationError(): void {
    this.operationStateService.showOperationInProgress$.next(ExecutionState.error);
    this.operationStateService.setBarMessage(
      'alert_errorHandling.label_HTTP500',
      'alert_errorHandling.subtitle'
    );
  }

  handleGenericError(): void {
    this.operationStateService.showOperationInProgress$.next(ExecutionState.error);
    this.operationStateService.setBarMessage(
      'alert_errorHandling.label_HTTP500',
      'alert_errorHandling.subtitle'
    );
  }

  private handleCustom4445Error(): void {
    this.operationStateService.showOperationInProgress$.next(ExecutionState.error);
    this.operationStateService.setBarMessage(
      'form.placeholder.label_account_disabled',
      'form.placeholder.label_subtitle'
    );
  }
}
